<div class="w-100 bg-grey-200" *ngIf="articleView">
  <div class="ad-skin d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adConfigMap| mapGet: 'skin'"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
  <flo-lazy
    [componentConstructor]="AdComponent"
    [initialProps]="adConfigMap| mapGet: 'interstitial'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
  <div class="py-3 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adConfigMap | mapGet: 'leaderboard-large'"
      [detectorHeight]="90"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
  <div
    class="py-3 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container"
  >
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adConfigMap | mapGet: 'leaderboard-small'"
      [detectorHeight]="90"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
  </div>
  <main class="container container-fluid min-vh-100 px-0">
    <div class="w-100 pt-2 pt-lg-4 pb-3 px-3 px-md-0 px-lg-4">
      <div class="px-xl-2">
        <a
          data-test="drillthrough-link"
          class="headline color-ignite font-bold text-uppercase"
          *ngIf="articleView.drillThrough as drillThrough"
          [routerLink]="drillThrough?.slug_uri"
        >{{ drillThrough?.name }}</a
        >
        <h1
          class="d-none d-md-block display-2"
          data-test="article-title"
        >{{ articleView.title }}</h1>
        <h1
          class="d-block d-md-none h2 pt-2"
          data-test="article-title"
        >{{ articleView.title }}</h1>
        <h2
          class="h4 font-bold text-700"
          data-test="description"
        >{{ articleView.description }}</h2>
        <flo-author-date
          [firstName]="authorFirstName"
          [lastName]="authorLastName"
          [date]="publishDate"
        ></flo-author-date>
      </div>
    </div>
    <!-- 3 columns, social, main, rail -->
    <div class="row g-0">
      <div class="col-12 col-lg-8 mt-0 mt-sm-2 px-lg-3 px-xl-4 border-lg-right">
        <!-- inner padding div -->
        <div class="px-xl-2 d-flex flex-column flex-md-row">
          <!-- social -->
          <div
            class="social-share me-md-4 pe-md-1 px-3 px-md-0 pb-4 pb-md-0"
            data-test="article-social-share"
          >
            <div class="d-flex flex-row flex-md-column stick-to-header">
              <div class="social-share-icon" data-test="article-social-icons">
                <flo-twitter-share-icon
                  floAnalytics
                  tagName="Button"
                  name="Share on Twitter"
                  [title]="articleView.title"
                  [shareableLink]="articleView.shareableLink"
                ></flo-twitter-share-icon>
              </div>
              <div class="social-share-icon">
                <flo-facebook-share-icon
                  [shareableLink]="articleView.shareableLink"
                  floAnalytics
                  tagName="Button"
                  name="Share on Facebook"></flo-facebook-share-icon>
              </div>
            </div>
          </div>
          <!-- main -->
          <div class="w-100 pb-0 pb-md-4" data-test="article-main-content">
            <flo-video-player
              *ngIf="articleView?.heroVideo"
              data-test="hero"
              class="video-player"
              [video]="articleView.heroVideo"
              [isAutoPlayed]="true"
              [volumeControls]="{ isMuted: true }"
              [currentVideoId]="articleView.heroVideo?.id"
              [isEmbedded]="true"
            ></flo-video-player>
            <div class="rounded bg-300 ratio ratio-16x9" *ngIf="!articleView?.heroVideo">
              <!-- add responsive image -->
              <img
                data-test="hero"
                [src]="articleView.assetUrl | floImage: 1200:650 | async"
                [alt]="articleView.title"
                class="w-100 h-auto rounded"
                loading="lazy"
              />
            </div>

            <div class="content pt-1 pb-4 mt-4 w-100 text-700">
              <ng-container
                *ngIf="articleView.showPaywall"
                >
                <div class="teaser content-font-size" data-test="teaser">
                  <div
                    *ngIf="articleView.previewContent"
                    [innerHtml]="articleView.previewContent | floSanitizeHtml"
                  ></div>
                  <div
                    class="paywall-overlay"
                  ></div>
                </div>
                <flo-paywall
                  data-test="article-paywall"
                  wrapped="true"
                  [redirect]="articleView.slugUri"
                  contentType="article"
                  [loggedIn]="articleView.userLoggedIn"
                  [promptOverride]="articleView.paywallMessaging"
                ></flo-paywall>
              </ng-container>
              <!-- preview_text div here -->
              <!-- <div data-test="article-teaser"></div>-->
              <div
                data-test="content"
                class="w-100 full-content content-font-size content-line-height px-3 px-md-0"
                [ngClass]="{
                  'd-none content-paywall': articleView.showPaywall
                }"
                [innerHtml]="articleView?.content | floSanitizeHtml"
                floDynamicContent
              >
              </div>
            </div>
            <div
              data-test="tags-wrapper"
              class="pt-1 px-3 px-md-0"
              *ngIf="articleView?.tags"
            >
              <flo-tags
                collectionTabUriPart="/article"
                [tags]="articleView.tags"
              ></flo-tags>
            </div>
            <!-- mobile ad -->
            <div class="d-flex d-lg-none justify-content-center pt-5 pb-3">
              <flo-lazy
                [componentConstructor]="AdComponent"
                [initialProps]="adConfigMap | mapGet: 'rectangle-mobile'"
                [detectorHeight]="250"
                (componentLoaded)="loadedAdsPush($event)"
              ></flo-lazy>
            </div>
            <div
              *ngIf="belowContentNotEmpty"
              class=" px-3 px-md-0 pt-5 pb-3"
            >
              <div class="border-bottom mb-3">
                <flo-slim-header [title]="belowContentTitle"></flo-slim-header>
              </div>
              <ul class="row below-content-grid pt-2 pt-md-1" data-test="below-content-related-content">
                <li
                  *ngFor="let content of belowRelatedContent; trackBy: trackByContentId"
                  class="col-6 col-md-4 pb-4"
                >
                  <a
                    *ngIf="content.contentItem.type === 'video' && content.contentItem.drill_through_url; else notVideo"
                    class="primary-color-text-hover"
                    floAnalytics
                    [routerLink]="content.contentItem.drill_through_url"
                    [queryParams]="{ playing: content.analytics.node_id }"
                    [analyticsProperties]="content.analytics"
                  >
                    <flo-spotlight
                      [title]="content.contentItem.title"
                      [imageUrl]="content.contentItem.asset_url"
                      [publishDate]="content.contentItem.publish_start_date"
                      [premium]="content.analytics.is_premium"
                      [duration]="content.contentItem.duration"
                      [smallThumbnail]="true"
                    ></flo-spotlight>
                  </a>
                  <ng-template #notVideo>
                    <a
                      floAnalytics
                      [routerLink]="content.contentItem.slug_uri"
                      [analyticsProperties]="content.analytics"
                      class="primary-color-text-hover"
                    >
                      <flo-spotlight
                        [title]="content.contentItem.title"
                        [imageUrl]="content.contentItem.asset_url"
                        [publishDate]="content.contentItem.publish_start_date"
                        [premium]="content.analytics.is_premium"
                        [smallThumbnail]="true"
                      ></flo-spotlight>
                    </a>
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
          <!-- end main content  flex column -->
        </div>
        <!-- end inner padding div -->
      </div>
      <!-- end row div  -->
      <!-- rail, hidden on mobile -->
      <aside data-test="article-rail" class="d-none d-lg-block col-lg-4 px-3 px-lg-0 pt-0 pt-sm-2">
        <div class="px-lg-2">
          <div class="d-none d-lg-flex justify-content-center lazy-flex-container">
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="adConfigMap | mapGet: 'rectangle-small'"
              [detectorHeight]="250"
              (componentLoaded)="loadedAdsPush($event)"
            ></flo-lazy>
          </div>
          <div
            class="py-3 pb-4 mt-sm-4 px-md-4 mx-md-2"
            (floLazyLoad)="showNewsletter = true"
            *ngIf="!articleView.userLoggedIn"
          >

            <flo-newsletter-widget
              *ngIf="showNewsletter"
              data-test="newsletter"
            >
            </flo-newsletter-widget>
          </div>
        </div>
        <div class="px-xl-2 py-3 stick-to-header">
          <div
            class="d-none d-lg-flex justify-content-center py-3 lazy-flex-container"
          >
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="adConfigMap | mapGet: 'rectangle-large-sticky'"
              [detectorHeight]="250"
              (componentLoaded)="loadedAdsPush($event)"
            ></flo-lazy>
          </div>
        </div>
      </aside>
    </div>
  </main>
  <div class="stick-to-footer d-sm-none">
    <div class="adhesion-ad">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adConfigMap | mapGet: 'adhesion'"
        (componentLoaded)="loadedAdsPush($event)"
      ></flo-lazy>
    </div>
  </div>
</div>
